import { Link } from "react-router-dom";
import Container from "components/container";
import Heading from "components/heading";
import { BasicSection, GridPanel1 } from "components/styles";
import styled from "@emotion/styled";

const ListPanel = styled.ul({
  paddingTop: "1.25rem",
  "& li": {
    marginLeft: "1.25rem",
    paddingLeft: "0.5rem",
    paddingTop: "0.25rem",
  },
  "& a": {
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
});

const NewsAndAnnouncements = () => (
  <main>
    <Heading
      isHome={false}
      name="Nexus Risk Management"
      title={["News and", "Announcements"]}
    />
    <BasicSection background="light-blue">
      <Container>
        <GridPanel1>
          <div>
            <h2>Press Releases</h2>
            <ListPanel>
              <li>
                <Link
                  to="/documents/press-releases/Press Release - Nexus Opens Montreal Office.pdf"
                  target="_blank"
                >
                  Montreal, July 1, 2025 - Nexus Risk Management Announces New
                  Office in Montreal
                </Link>{" "}
                (
                <Link
                  to="/documents/press-releases/Communiqué de presse - Nexus ouvre un bureau à Montréal.pdf"
                  target="_blank"
                >
                  Version française
                </Link>
                )
              </li>
              <li>
                <Link
                  to="/documents/press-releases/Press Release - ARNEX 250616.pdf"
                  target="_blank"
                >
                  Austin, June 16, 2025 - ARNEX Capital Management Launches to
                  Revolutionize the Financial Landscape and Transform Asset
                  Liability Management
                </Link>
              </li>
              <li>
                <Link
                  to="/documents/press-releases/Press Release - Nexus Appoints Hélène Baril as Executive Vice President.pdf"
                  target="_blank"
                >
                  Toronto, May 1, 2025 - Nexus Appoints Hélène Baril as
                  Executive Vice President
                </Link>
              </li>
            </ListPanel>
          </div>
        </GridPanel1>
      </Container>
    </BasicSection>
  </main>
);

export default NewsAndAnnouncements;
